import { render, staticRenderFns } from "./sBanner.vue?vue&type=template&id=3d7e0be8&scoped=true"
import script from "./sBanner.vue?vue&type=script&lang=js"
export * from "./sBanner.vue?vue&type=script&lang=js"
import style0 from "./sBanner.vue?vue&type=style&index=0&id=3d7e0be8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d7e0be8",
  null
  
)

export default component.exports